// Shutterfly Icons
import PasswordShowIcon from './../themes/base/img/eye.svg';
import PasswordHideIcon from './../themes/base/img/eye-slash.svg';
import PasswordShowIconError from './../themes/base/img/eye-error.svg';
import PasswordHideIconError from './../themes/base/img/eye-slash-error.svg';
import TickIcon from './../themes/base/img/tick.svg';
import InformationSelectedIcon from './../themes/base/img/information-selected.svg';

// Lifetouch Icons
import LifetouchPasswordShowIcon from './../themes/mlt/img/eye.svg';
import LifetouchPasswordHideIcon from './../themes/mlt/img/eye-slash.svg';
import LifetouchPasswordShowIconError from './../themes/mlt/img/eye-error.svg';
import LifetouchPasswordHideIconError from './../themes/mlt/img/eye-slash-error.svg';

// Brand Logos
import ShutterflyLogo from './../themes/base/img/sfly_logo.svg';
import TinyprintsLogo from './../themes/base/img/tp_logo.svg';
import LifetouchLogo from './../themes/base/img/lt_logo.svg';

import {
    SET_ICON_SOURCE
} from '../actions/ActionTypes';

// The default icon sets
const iconSets = {
    base: {
        passwordShow: PasswordShowIcon,
        passwordHide: PasswordHideIcon,
        passwordShowError: PasswordShowIconError,
        passwordHideError: PasswordHideIconError,
        tick: TickIcon,
        informationSelected: InformationSelectedIcon,
        logos: {
            shutterfly: ShutterflyLogo,
            tinyprints: TinyprintsLogo,
            lifetouch: LifetouchLogo
        },

    },
    lifetouch: {
        passwordShow: LifetouchPasswordShowIcon,
        passwordHide: LifetouchPasswordHideIcon,
        passwordShowError: LifetouchPasswordShowIconError,
        passwordHideError: LifetouchPasswordHideIconError
    }
};

const initialState = iconSets.base;

export function iconReducer(state = initialState, action) {
    switch(action.type) {
        case SET_ICON_SOURCE:
            if(action.source !== 'base') {
                return Object.assign(iconSets.base, iconSets[action.source]);
            } else {
                return state;
            }
        default:
            return state;
    }
}